/**
 * Calculate the height of a week based on the number of sessions in the day with the most sessions
 */
 export function calculateWeekHeight(maxEventsInWeek: number): number {
   if (maxEventsInWeek === 0) return 75; // Default height

   // Apply the specific height rules
   if (maxEventsInWeek === 1) return 75;
   if (maxEventsInWeek === 2) return 110;
   if (maxEventsInWeek === 3) return 135;
   if (maxEventsInWeek === 4) return 162;
   if (maxEventsInWeek === 5) return 190;
   if (maxEventsInWeek === 6) return 220;

   // For more than 6 events
   return 240;
 }

/**
 * Gets the current visible month as a Date to preserve calendar position
 */
export const getCurrentVisibleMonth = (): Date => {
  // Default to current month if not found
  const storedMonth = sessionStorage.getItem('calendarCurrentMonth');
  if (storedMonth) {
    try {
      return new Date(storedMonth);
    } catch (e) {
      console.error('Error parsing stored month:', e);
    }
  }
  return new Date();
};

/**
 * Saves the current visible month to sessionStorage
 */
export const saveCurrentVisibleMonth = (date: Date): void => {
  try {
    sessionStorage.setItem('calendarCurrentMonth', date.toISOString());
  } catch (e) {
    console.error('Error saving current month:', e);
  }
};
